import Touchable from "src/components/Touchable";
import usePalette from "src/hooks/usePalette";
import useStyle from "src/hooks/useStyle";
import IconSend from "src/icons/IconSend";
import { color } from "src/styles";

const CommentSendButton = ({
	onPress,
	disabled,
	size = 48,
}: {
	onPress?: () => void;
	disabled?: boolean;
	size?: number;
}) => {
	const { theme } = useStyle();
	const { primary, isFallback } = usePalette();

	return (
		<Touchable
			testID="CommentSendButton"
			onPress={onPress}
			disabled={disabled}
			containerStyle={{
				width: size,
				height: size,
				borderRadius: size / 2,
				backgroundColor: disabled
					? color.Disabled[theme]
					: isFallback
						? color.Action[theme]
						: primary,
			}}
			style={{
				alignItems: "center",
				justifyContent: "center",
				flex: 1,
			}}
		>
			<IconSend size={Math.floor(0.6 * size)} />
		</Touchable>
	);
};
export default CommentSendButton;
